<template>
  <div class="innerBox">
    <h1>Quotation Baru</h1>

    <div class="col row mt-5 mb-5">
      <div class="col-md" :class="mobile ? 'pt-20' : ''">
        <label class="font-weight-bold">Nama Pelanggan<span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Ketik Nama Pelanggan" style="height: 43px;" v-model="form.name">
      </div>
      <div class="col-md" :class="mobile ? 'pt-20' : ''">
        <label class="font-weight-bold">Nomor Telepon<span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Ketik Nomor Telepon" style="height: 43px;" v-model="form.phone_number">
      </div>
      <div class="col-md" :class="mobile ? 'pt-20' : ''">
        <label class="font-weight-bold">Nomor Polisi Mobil<span style="color: red;">*</span></label>
        <input type="text" class="form-control" placeholder="Ketik Nomor Polisi mobil" style="height: 43px;" v-model="form.registration">
      </div>
      <div class="col-md" :class="mobile ? 'pt-20' : ''">
        <label class="font-weight-bold">Merk Mobil<span style="color: red;">*</span></label>
        <MultiSelect
          v-model="sparepart_brand_id"
          :options="options.brand.map(x => x.id)"
          :custom-label="opt => options.brand.find(x => x.id == opt).name"
          :searchable="true"
          :close-on-select="true"
          :multiple="false"
          :allow-empty="false"
          placeholder="Pilih Merk Mobil"
        ></MultiSelect>
      </div>
      <div class="col-md" :class="mobile ? 'pt-20' : ''">
        <label class="font-weight-bold">Tipe Mobil<span style="color: red;">*</span></label>
        <MultiSelect
          v-model="form.car_id"
          :disabled="sparepart_brand_id == ''"
          :options="options.model.map(x => x.id)"
          :custom-label="opt => options.model.find(x => x.id == opt).name"
          :searchable="true"
          :close-on-select="true"
          :multiple="false"
          :allow-empty="false"
          :placeholder="(sparepart_brand_id == '') ? 'Pilih Merk Terlebih Dahulu' : 'Pilih Tipe Mobil'"
        ></MultiSelect>
      </div>
    </div>

    <div class="row mb-2">
      <div class="col-md-6" style="padding: 0 30px">
        <label class="font-weight-bold">Harga Total</label>
        <p style="font-size:2rem" :style="{'text-decoration: underline' : overallTotal!=0}">Rp. {{ numberWithCommas(overallTotal) }}</p>
      </div>
      <div class="col-md-6 text-right" style="display: flex; flex-direction: column-reverse;">
        <div>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="modal.add = true"
            title="Pilih Mobil Terlebih Dahulu"
            :disabled="form.car_id == null || form.car_id == ''"  
          >Tambah Sparepart</button>
        </div>
      </div>
    </div>
    <table class="table table-striped">
      <thead>
        <tr>
          <th>No</th>
          <th>Nama Sparepart</th>
          <th>Tipe</th>
          <th>Deskripsi Sparepart</th>
          <th>Jumlah</th>
          
          <th>Harga Satuan</th>
          <th>Harga Total</th>
          <th><i class="fas fa-cog"></i></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(sparepart, index) in form.spareparts">
          <td>{{ index+1 }}</td>
          <td>{{ sparepart.sparepart_name }}</td>
          <td>{{ sparepart.sparepart_type=="J" ? 'Jasa' :
                 sparepart.sparepart_type=="P" ? 'Part' :
                 sparepart.sparepart_type=="B" ? 'Bahan' : '' }}</td>
          <td>{{ sparepart.part_number }}</td>
          <td>{{ numberWithCommas(sparepart.quantity) }}</td>
          
          <td v-if="sparepart.sparepart_type == 'J'">Rp. {{ numberWithCommas(sparepart.supplier_prices[0].price_per_item) }}</td>
          <td v-else>Rp. {{numberWithCommas(sparepart.estimated_price)}}</td>
          <td v-if="sparepart.sparepart_type == 'J'">Rp. {{ numberWithCommas(sparepart.quantity * sparepart.supplier_prices[0].price_per_item) }}</td>
          <td v-else>Rp. {{ numberWithCommas(sparepart.quantity * sparepart.estimated_price) }}</td>
          <td>
            <button type="button" class="btn btn-outline-danger" @click="form.spareparts.splice(index, 1)">
              <i class="fas fa-times"></i>
            </button>
          </td>
        </tr>
        <tr v-if="form.spareparts.length == 0">
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>-</td>
          <td>X</td>
        </tr>
      </tbody>
    </table>

    <div class="row mt-5 mb-5">
      <div class="col text-center">
        <button type="button" class="btn btn-outline-danger" style="width: 75px;" @click="goBack">Kembali</button>
        <button type="button" class="btn btn-primary ml-5" style="width: 75px;" @click="submitForm">Buat</button>
      </div>
    </div>

    <add-sparepart
      v-if="modal.add"
      @closeModal="modal.add = false"
      @addSparepart="addSparepart"
      :brand_id="sparepart_brand_id"
    ></add-sparepart>

  </div>
</template>

<script>
  import addSparepart from './children/addSparepart'

  export default {
    data () {
      return {
        modal : {
          add : false,
        },
        mobile : this.isMobile(),
        options : this.$store.getters.getFilterOptions,
        sparepart_brand_id : '',
        form : {
          name : '',
          phone_number : '',
          car_id : '',
          registration : '',
          spareparts : []
        },
        processing : false
      }
    },
    components : {
      addSparepart
    },
    mounted () {

    },
    watch : {
      'sparepart_brand_id'(){
        // console.log(JSON.stringify(this.$store.getters.getSingleModelId(this.form.brand)));
        this.form.car_id = '';
        this.options.model = this.$store.getters.getSingleModelId(this.sparepart_brand_id)
      },
      'form.registration' : function () {
				const result = this.form.registration.toUpperCase();
				this.$nextTick(() => this.form.registration = result);
			},
    },
    computed : {
      overallTotal(){
        var total = 0;
        for(var i in this.form.spareparts){
          let price = this.form.spareparts[i].sparepart_type == 'J' ? this.form.spareparts[i].supplier_prices[0].price_per_item : this.form.spareparts[i].estimated_price
          total += (price * this.form.spareparts[i].quantity)
        }
        return total;
      }
    },
    methods : {
      addSparepart(a){
        this.form.spareparts.push(a);
        console.log(this.form.spareparts)
        this.modal.add = false;
      },
      validateForm(){
        var valid = true;
        var error = [];

        if(this.form.name == '' || this.form.name == null){//Customer Name [Required]
          valid = false;
          error.push('Nama pelanggan wajib terisi');
        }

        if(this.form.phone_number == '' || this.form.phone_number == null){//Nomor Telepon [Required]
          valid = false;
          error.push('Nama Telepon wajib terisi');
        }

        if(this.form.car_id == '' || this.form.car_id == null){//Car ID [Required]
          valid = false;
          error.push('Tipe mobil wajib terisi');
        }

        if(this.form.spareparts.length == 0){//Spareparts [Required]
          valid = false;
          error.push('Wajib ditambahkan setidaknya 1 suku cadang');
        }

        if(!valid) this.$store.dispatch('triggerAlert', [false, error]);
        else return valid;
      },
      async submitForm(){
        let vm = this;
        if(this.processing) {
          this.$store.dispatch('triggerAlert' , [false , 'Customer Quotation is processing. please wait.'])
          return
        }
        this.processing = true
        if(vm.validateForm()){
          for(var i in this.form.spareparts){
            delete this.form.spareparts[i].sparepart_type
            delete this.form.spareparts[i].sparepart_name
          }
          this.$http.post('/api/v1/quotation', {data:this.form})
          .then((resp)=>{
            this.$swal.fire({
              title: resp.data.data.form_code,
              text: 'Kode Referensi',
              type: 'success'
            }).then((result)=>{
              this.$router.push({name : 'CSOCustomerQuotationView'});
              this.processing = false
            })
          })
          .catch((err)=>{
            console.log(err.response.data);
            this.$store.dispatch('triggerAlert' , [false , err.response.data.data])
            this.processing = false
          })
        }
        else {
          this.processing = false
        }
      },
      goBack(){
        this.$swal.fire({
          title: 'Apakah anda yakin?',
          text: 'Anda akan menghapus semua yang telah terisi!',
          icon: 'error',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Saya Yakin',
          cancelButtonText: 'Kembali'
        }).then((result)=>{
          if(result.value){
            this.$router.push({name : 'CSOCustomerQuotationView'});
          }
        })
      },
    }
  }
</script>

<style scoped>
  table thead tr th, table tbody tr td{
    text-align: center;
    vertical-align: middle;
  }
</style>